import { InboundPacketType } from "./InboundPacketType.js";
import type { PacketIn } from "./PacketIn.js";
import { PacketInPong } from "./PacketInPong.js";
import { PacketInError } from "./PacketInError.js";
import { PacketInSetID } from "./PacketInSetID.js";
import { PacketInJoinLobby } from "./PacketInJoinLobby.js";
import { PacketInUnknownLobby } from "./PacketInUnknownLobby.js";
import { PacketInPlayerData } from "./PacketInPlayerData.js";
import { PacketInGame } from "./PacketInGame.js";
import { PacketInLobbyStatus } from "./PacketInLobbyStatus.js";
import { PacketInReaction } from "./PacketInReaction.js";
import { PacketInQueueState } from "./PacketInQueueState.js";
import { PacketInRemovedFromQueue } from "./PacketInRemovedFromQueue.js";
import { PacketInEarnedAchievements } from "./PacketInEarnedAchievements.js";


export function buildPacketIn(type: InboundPacketType): PacketIn {
    // General.
    if (type === InboundPacketType.PONG)
        return new PacketInPong();
    if (type === InboundPacketType.ERROR)
        return new PacketInError();
    if (type === InboundPacketType.SET_ID)
        return new PacketInSetID();

    // Matchmaking.
    if (type === InboundPacketType.QUEUE_STATE)
        return new PacketInQueueState();
    if (type === InboundPacketType.REMOVED_FROM_QUEUE)
        return new PacketInRemovedFromQueue();

    // Lobbies.
    if (type === InboundPacketType.JOIN_LOBBY)
        return new PacketInJoinLobby();
    if (type === InboundPacketType.UNKNOWN_LOBBY)
        return new PacketInUnknownLobby();
    if (type === InboundPacketType.LOBBY_STATUS)
        return new PacketInLobbyStatus();

    // Games.
    if (type === InboundPacketType.PLAYER_DATA)
        return new PacketInPlayerData();
    if (type === InboundPacketType.GAME)
        return new PacketInGame();
    if (type === InboundPacketType.REACTION)
        return new PacketInReaction();
    if (type === InboundPacketType.EARNED_ACHIEVEMENTS)
        return new PacketInEarnedAchievements();

    throw new Error("Unknown packet type: " + type.getName());
}
